module.exports = __webpack_public_path__ + "img/brand-wallapop.98fe0825.svg";